import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=0c8139fa"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js"
import style0 from "./CalendarSidebar.vue?vue&type=style&index=0&id=0c8139fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports